import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Box, Stack } from "@mui/material";

import { EllipsisText } from "../../../../ellipsis-text/EllipsisText";

interface ParticipantCellProps {
  name: string | null;
  address: string | null;
  isInactive: boolean;
  inactiveTooltip: string;
  muted?: boolean;
}

export function ParticipantCell({ name, address, isInactive, inactiveTooltip, muted }: ParticipantCellProps) {
  if (!name) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "100%",
        py: 0.5,
        lineHeight: 1.3,
      }}
    >
      <Stack direction="row" spacing={0.5} alignItems="center" sx={{ overflow: "hidden", minWidth: 0 }}>
        <Box sx={{ minWidth: 0, flex: "0 1 auto", overflow: "hidden" }}>
          <EllipsisText value={name} variant="body2" fontWeight={600} color={muted ? "text.disabled" : undefined} />
        </Box>
        {isInactive && (
          <WarningAmberIcon fontSize="small" color="warning" titleAccess={inactiveTooltip} sx={{ flexShrink: 0 }} />
        )}
      </Stack>
      {address && (
        <Box sx={{ minWidth: 0, overflow: "hidden" }}>
          <EllipsisText value={address} variant="caption" color={muted ? "text.disabled" : "text.secondary"} />
        </Box>
      )}
    </Box>
  );
}
